"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _reactNative = require("react-native");

var _Text = require("../Text");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var styles = _reactNative.StyleSheet.create({
  item: {
    flex: 1,
    backgroundColor: 'black',
    borderColor: 'black',
    borderWidth: 1,
    justifyContent: 'center',
    alignItems: 'center'
  }
});

var RestItem = function RestItem(_ref) {
  var item = _ref.item,
      width = _ref.width,
      index = _ref.index,
      _ref$isActive = _ref.isActive,
      isActive = _ref$isActive === void 0 ? false : _ref$isActive;

  var _React$useState = React.useState(item.timer || 10),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      countDown = _React$useState2[0],
      setCountDown = _React$useState2[1];

  React.useEffect(function () {
    if (isActive) {
      var intervalId = setInterval(function () {
        if (countDown - 1 === 0) {
          clearInterval(intervalId);
        }

        if (countDown === 0) {
          return;
        }

        setCountDown(countDown - 1);
      }, 1000);
      return function () {
        clearInterval(intervalId);
      };
    }
  });
  return /*#__PURE__*/React.createElement(_reactNative.View, {
    style: [styles.item]
  }, /*#__PURE__*/React.createElement(_Text.Text, {
    style: {
      color: isActive ? "white" : "grey"
    }
  }, "Repos"), isActive && /*#__PURE__*/React.createElement(_Text.Text, {
    style: {
      color: isActive ? "white" : "grey"
    }
  }, " => ".concat(countDown, " secondes")));
};

var ExerciceItem = function ExerciceItem(_ref2) {
  var item = _ref2.item,
      width = _ref2.width,
      index = _ref2.index,
      _ref2$isActive = _ref2.isActive,
      isActive = _ref2$isActive === void 0 ? false : _ref2$isActive;
  return /*#__PURE__*/React.createElement(_reactNative.View, {
    style: [styles.item]
  }, /*#__PURE__*/React.createElement(_Text.Text, {
    style: {
      color: isActive ? "white" : "grey"
    }
  }, item.getTitle()));
};

var _default = function _default(props) {
  var Component = ExerciceItem;

  if (props.item.type === "rest") {
    Component = RestItem;
  }

  return /*#__PURE__*/React.createElement(Component, props);
};

exports["default"] = _default;